import React, {Component} from 'react';
import Header from './Shared/Header';
import ArticlePage from './Articles/ArticlePage';
import BottonPushes from './Shared/BottonPushes';
import detectBots from "./Shared/DetectBots";
import shortid from "shortid";
import Breadcrumbs from "./Header/Breadcrumbs";
import isBreadcrumb from 'Shared/isBreadcrumb';
import ShareBox from 'Shared/ShareBox';

class ArticlePageContent extends Component {
    constructor(props) {
        super(props);
    }
    render() {
        return (
            <div>
                {this.props.article.Model.Slider.length > 0 ? (
                    <Header
                        topHeader={this.props.article.Model.Slider[0]}
                        newClassName={`vh-section ${detectBots() ? "bot" : "full-height"}`}
                        breadcrumbs={this.props.breadcrumbs}
                    />
                ) : (
                    <Breadcrumbs breadcrumbProps={isBreadcrumb(this.props.breadcrumbs)} />
                )}
                {this.props.article.Model.Articles ? (
                    <div className="main">
                        {this.props.article.Model.Articles.map((article) => {
                            return <ArticlePage key={shortid.generate()} article={article} />
                        })}
                        <ShareBox
                            MetaPageTitle={this.props.article.Model.MetaPageTitle}
                            MetaPageDescription={this.props.article.Model.MetaPageDescription}
                            lang={this.props.lang}
                        />
                    </div>
                ) : null}
                {this.props.article.Model.BlogItems ? (
                    <div>
                        <div className="main">
                            {this.props.article.Model.BlogItems.map((article) => {
                                return <ArticlePage key={shortid.generate()} article={article} />
                            })}
                            <a className="button button-article-page" href={"/" + location.pathname.split("/")[1] + "/blogs"}>GO BACK TO MIND. BODY. HAIR.</a>
                        </div>
                        <BottonPushes salonFinder={this.props.article.Model} bottonPushes={this.props.article.Model.BottomTiles} salonCountries={this.props.salonCountries} />
                    </div>
                ) : null}
            </div>
        )
    }
}

export default ArticlePageContent;
